import {html} from 'lit';

export default function(self) {
    return html`
        <svg>
            <use href="${(self.path + self.icon)}"></use>
        </svg>
    `;
}